import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Gamepad2, Menu, X } from 'lucide-react';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-dark/90 backdrop-blur-md border-b border-white/10 py-3' : 'bg-transparent py-5'}`} data-id="element-184">
      <div className="container mx-auto px-6 flex items-center justify-between" data-id="element-185">
        <div className="flex items-center gap-2" data-id="element-186">
          <div className="relative flex items-center justify-center w-10 h-10 rounded-lg bg-dark-lighter border border-neon-cyan/30 glow-cyan" data-id="element-187">
            <Gamepad2 className="text-neon-cyan w-6 h-6" data-id="element-188" />
          </div>
          <span className="font-rajdhani text-2xl font-bold tracking-wider text-white" data-id="element-189">
            PIXEL<span className="text-neon-cyan text-glow-cyan" data-id="element-190">KEEP</span>
          </span>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-191">
          {['Platform', 'Teams', 'Brands', 'Pricing', 'About'].map(item => <a key={item} href={`#${item.toLowerCase()}`} className="text-sm font-medium text-gray-300 hover:text-neon-cyan transition-colors" data-id="element-192">
              {item}
            </a>)}
        </nav>

        <div className="hidden md:flex items-center gap-4" data-id="element-193">
          <button className="text-sm font-medium text-white hover:text-neon-cyan transition-colors" data-id="element-194">
            Login
          </button>
          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="px-5 py-2.5 bg-neon-cyan text-dark font-bold text-sm rounded-md shadow-[0_0_15px_rgba(0,243,255,0.4)] hover:shadow-[0_0_25px_rgba(0,243,255,0.6)] transition-shadow" data-id="element-195">
            Get Early Access
          </motion.button>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-196">
          {mobileMenuOpen ? <X data-id="element-197" /> : <Menu data-id="element-198" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="absolute top-full left-0 w-full bg-dark border-b border-white/10 py-4 px-6 flex flex-col gap-4 md:hidden" data-id="element-199">
          {['Platform', 'Teams', 'Brands', 'Pricing', 'About'].map(item => <a key={item} href={`#${item.toLowerCase()}`} className="text-lg font-medium text-gray-300 hover:text-neon-cyan" onClick={() => setMobileMenuOpen(false)} data-id="element-200">
              {item}
            </a>)}
          <div className="h-px bg-white/10 my-2" data-id="element-201" />
          <button className="w-full px-5 py-3 bg-neon-cyan text-dark font-bold rounded-md shadow-[0_0_15px_rgba(0,243,255,0.4)]" data-id="element-202">
            Get Early Access
          </button>
        </motion.div>}
    </header>;
}